import React, { useState, useEffect } from "react";
import axios from "axios";
import { Spin } from "antd";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import CloseIcon from "@mui/icons-material/Close";
import "../team/teamModal.css";

const ViewTesterDetails = ({ testerId, setOpen }) => {
  const [testerData, setTesterData] = useState(null);
  const apiUrl = process.env.REACT_APP_API_Testers;

  useEffect(() => {
    const fetchTesterDetails = async () => {
      try {
        const response = await axios.get(`${apiUrl}/${testerId}`);
        setTesterData(response.data.body);
      } catch (error) {
        console.error("Error fetching tester details:", error);
      }
    };

    fetchTesterDetails();
    return () => {
      setTesterData(null);
    };
  }, [testerId]);

  if (!testerData) {
    return (
      <div className="team-modal-loading" style={{ padding: 48 }}>
        <Spin size="large" />
      </div>
    );
  }

  const fields = [
    { label: "First Name", value: testerData.first_name },
    { label: "Last Name", value: testerData.last_name },
    { label: "Email", value: testerData.email },
    { label: "CNIC", value: testerData.cnic },
    { label: "Contact Number", value: testerData.contact_number },
    { label: "Gender", value: testerData.gender },
    { label: "Last Login", value: testerData.last_login },
    { label: "Bank Name", value: testerData.bank_name },
    { label: "Account Title", value: testerData.account_title },
    { label: "Account Number", value: testerData.account_number },
  ];

  return (
    <>
      <AppBar className="team-modal-appbar" position="relative">
        <Toolbar>
          <Typography className="team-modal-title" variant="h6" component="div" sx={{ flex: 1 }}>
            Tester Details
          </Typography>
          <IconButton
            edge="end"
            color="inherit"
            onClick={() => setOpen(false)}
            aria-label="close"
            className="team-modal-close-btn"
          >
            <CloseIcon />
          </IconButton>
        </Toolbar>
      </AppBar>
      <div className="view-detail-body">
        <div className="view-detail-cards">
          {fields.map(({ label, value }) => (
            <div key={label} className="view-detail-row">
              <span className="team-detail-label">{label}</span>
              <span className="team-detail-value">{value ?? "—"}</span>
            </div>
          ))}
        </div>
      </div>
    </>
  );
};

export default ViewTesterDetails;
